import { render, staticRenderFns } from "./BaseCookieBanner.vue?vue&type=template&id=a1e28644&lang=html&"
import script from "./BaseCookieBanner.vue?vue&type=script&lang=js&"
export * from "./BaseCookieBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports